/**
 * ContentLabelSettings entity class
 */

/**
 * ContentLabelSettingsFactory
 * returns ContentLabelSettings entity class
 *
 * @class ContentLabelSettingsFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ContentLabelSettings} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ContentLabelSettingsFactory
 */
/* @ngInject */
export default function ContentLabelSettingsFactory ($injector, $http, Type, Entity, onOffMixin) {
  /* === ContentLabelSettings class === */

  /**
   * ContentLabelSettings model
   *
   * @class ContentLabelSettings
   * @classdesc ContentLabelSettings model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.ContentLabelSettings} ContentLabelSettings entity
   */
  function ContentLabelSettings () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ContentLabelSettings.prototype = Object.create(Entity.prototype)
  ContentLabelSettings.prototype.constructor = ContentLabelSettings

  /* === ContentLabelSettings instance methods & fields === */

  Object.assign(ContentLabelSettings.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ContentLabelSettings#
     * @type {Object}
     */
    _fields: {
      networkId: Number,
      enabled: false,
      periodValue: 1,
      unit: 'DAYS'
    },

    /**
     * url template
     *
     * @memberof models.ContentLabelSettings#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/appearance/content-label-settings',

    /**
     * public url template
     *
     * @memberof models.ContentLabelSettings#
     * @type {String}
     */
    _publicUrlTemplate: 'networks/{{::networkId}}/appearance/content-label-settings',

    /**
     * Prepare note
     *
     * @memberof models.ContentLabelSettings#
     * @override
     */
    _prepare: function () {},

    /**
     * Get underlying object
     *
     * @memberof models.ContentLabelSettings#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      delete this.networkId
      return Entity.prototype._object.apply(this, arguments)
    }

  }, onOffMixin)

  /* === ContentLabelSettings static methods & fields === */

  /**
   * Generate url
   *
   * @param {Object} [o] - object over which Url will be interpolated
   * @param {String} [url]
   * @return {String}
   */
  ContentLabelSettings.generateUrl = function (url = '', o) {
    o = o || {}

    const cast = $injector.get(this._name)
    return `${cast.prototype.$_urlTemplate(o)}` + url
  }

  /**
   * Update content label settings
   *
   * @param {ContentLabelSettings} data - entity with updated values
   * @return {Promise} promise
   */
  ContentLabelSettings._update = function (data) {
    return $http.put(data._url, data._object())
      .then((response) => response.data)
  }

  Object.assign(ContentLabelSettings, Entity)
  ContentLabelSettings._name = 'ContentLabelSettings'
  ContentLabelSettings.init()

  ContentLabelSettings.access = {

  }

  return ContentLabelSettings
}
